import React from 'react';

export const WhyTherapyCardSecond = ({ Icon, title, description }) => {
    return (
        <div className="why-therapy-card-second-wrapper">
            <div className="why-therapy-card-second-icon-block">
                <Icon />
            </div>

            <div className="why-therapy-card-second-title_description">
                <h4 className="why-therapy-card-second-title">{title}</h4>

                <p className="why-therapy-card-second-description">{description}</p>
            </div>
        </div>
    );
};
